import src from "IMAGE";
export default { src, width: 28, height: 7, blurWidth: 0, blurHeight: 0};
